// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences" endpoint
 */
import type { UseCaseEnvironment } from "@dashboardApi/apis/offerfitShared/types";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAudiences } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdAudiences = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAudiences,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string,
    environment?: UseCaseEnvironment
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/audiences`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdAudiencesResult
);
